export const DRAFT = "DRAFT"
export const PUBLISHED = "PUBLISHED"

export const STATUS_OPTIONS = [DRAFT,PUBLISHED]